<template>
<div>
  <HeaderWrp/>
  <div class="checkout__success">
    <div class="icon">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.0029 41.6134L6.98438 27.5335L9.34396 25.0165L21.9255 36.8117L46.6194 12.1179L49.059 14.5572L22.0029 41.6134Z" fill="white"/>
      </svg>
    </div>
    <h1>{{$t('checkout.message')}}</h1>
    <span>{{$t('checkout.messageDesc')}}</span>
  </div>
  <FooterApp/>
</div>
</template>

<script>
import HeaderWrp from "@/components/HeaderWrp"
import FooterApp from "@/components/FooterApp";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    HeaderWrp,
    FooterApp
  },
  beforeMount(){
    this.resetShop();
  },
  computed:{
    ...mapGetters({
      langStorage : 'languages/getLang'
    })
  },
  methods:{
    ...mapMutations({
      resetShop: 'checkout/reset'
    })
  }
}
</script>
